import {State} from '../modules/slice'

export const setHeaders = (headers: Headers, state: State) => {
  const {
    userToken,
    xRequestId,
    clientUserAgent,
    xSapiVariations,
    vclid,
    boVioProfile
  } = state.api

  const headersMap = {
    'Content-Type': 'application/json',
    'X-Auth-Token': userToken,
    'X-Api-Key': boVioProfile,
    'X-Request-Id': xRequestId,
    'X-Client-User-Agent': clientUserAgent,
    'X-Sapi-variations': xSapiVariations,
    'X-Vclid': vclid
  }

  Object.entries(headersMap).forEach(([key, value]) => {
    if (value) headers.set(key, value)
  })

  return headers
}

export const getDealFreezeRetrieveBookingUrl = (bookingId: string) =>
  `bookings/deal-freeze/${bookingId}`
